<template>
    <v-dialog v-model="showModalModel" max-width="900">
        <v-card>
            <v-card-text>
                <p class="title text-xs-center mb-0">
                    {{ 'There are only' | translation }}
                    {{merchantQuota()}}
                    {{ 'products in stock and therefore the delivery is delayed' | translation }}
                    <span
                        class="shipping-estimation"
                        v-if="shippingDates"
                    >
                        {{shippingDates.est_from}}
                        {{shippingDates.est_to ? (' - ' + shippingDates.est_to) : ''}}
                    </span>
                </p>
            </v-card-text>
            <v-card-actions>
                <v-flex>
                    <v-btn
                        block
                        class="mb-2"
                        color="primary"
                        @click="addAvailableStock"
                        v-if="showAddAvailableStockButton"
                    >
                        {{merchantQuota()}} {{ 'products add to cart' | translation }}
                    </v-btn>
                    <v-btn
                        block
                        class="mb-2 ml-0"
                        color="primary"
                        @click="addCurrentQuantity"
                    >
                        {{amountValue}} {{ 'products add to cart' | translation }}
                    </v-btn>
                    <v-btn
                        block
                        class="ml-0"
                        color="primary"
                        @click.stop="showModalModel = false"
                    >
                        {{ 'Do not add to cart' | translation }}
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';

    const parentModuleName = 'Product';
    const {mapGetters, mapState, mapActions, mapMutations} = createNamespacedHelpers(parentModuleName);

    export default {
        name: 'OutOfStockModal',
        computed: {
            ...mapState({
                showModal: state => state.showOutOfStockModal,
                showAddAvailableStockButton() {
                    return this.merchantQuota() > 0;
                },
                amountValue: state => state.amountValue,
                shippingDates: state => {
                    let result = null;
                    if (
                        state.shippingEstimationDates &&
                        state.shippingEstimationDates[state.currentProductId] &&
                        state.shippingEstimationDates[state.currentProductId].delayed
                    ) {
                        result = state.shippingEstimationDates[state.currentProductId].delayed[state.currentMerchantId];
                    }

                    return result;
                },
                currentProduct: state => state.currentProductId,
                currentMerchant: state => state.currentMerchantId
            }),
            ...mapGetters(['merchantQuota']),
            showModalModel: {
                get() {
                    return this.showModal;
                },
                set(value) {
                    this.setShowOutOfStockModal(value);
                }
            }
        },
        watch: {
            showModal: function (value) {
                if (value) {
                    this.loadShippingEstimationDates({
                        item: this.currentProduct,
                        merchantIds: [this.currentMerchant]
                    });
                }
            }
        },
        methods: {
            ...mapActions(['loadShippingEstimationDates', 'buyProduct']),
            ...mapMutations(['setShowOutOfStockModal']),
            addAvailableStock() {
                this.showModalModel = false;
                this.buyProduct({
                    onlyAvailableQuantity: true,
                    keepProduct: true,
                });
            },
            addCurrentQuantity() {
                this.showModalModel = false;
                this.buyProduct({keepProduct: true});
            }
        }
    };
</script>